export const walkthroughPresenterPosterFolder = 'd-id.com/DefaultPresenters/William_m';
export const walkthroughPrompt =
    "I'm Jack! To see me talking, click Generate. Make it your own by uploading a voice/photo, or editing my script.";
